<template>
  <el-dialog v-dialogDrag title="内容构造器" :visible.sync="dlgVisible" width="500px" :close-on-click-modal="false">
    <div class="titleLine">原始内容</div>
    <el-input v-model="originContent" :type="inputType" disabled size="small"></el-input>

    <div class="titleLine">当前内容</div>
    <el-input v-model="content" :type="inputType" placeholder="请输入内容" size="small"></el-input>
    <el-button type="text" @click="resetToOrigin">重置</el-button>
    <div class="inlineChoice">
      <div v-for="(item, index) in fieldList" :key="index" class="choiceField" @click="choiceTitle(item)">
        {{ item.label }}
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dlgVisible = false">取 消</el-button>
      <el-button type="primary" size="small" @click="finishEdit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dlgVisible: false,
      multiLine: false,
      content: "",
      originContent: "",
      tag: null,
      fieldList: []
    };
  },

  computed: {
    inputType() {
      return this.multiLine ? 'textarea' : 'input';
    }
  },

  methods: {
    show(content, tag, fieldList, isMultiLine = 0) {
      this.content = content;
      this.originContent = content;
      this.tag = tag;
      this.fieldList = fieldList;
      this.multiLine = !!isMultiLine;
      this.dlgVisible = true;
    },

    choiceTitle(item) {
      const stringItem = "${" + item.formField + "}";
      this.content += stringItem;
    },

    resetToOrigin() {
      this.content = this.originContent;
    },

    finishEdit() {
      if (!this.content) {
        this.$warn("请输入内容");
        return;
      }
      this.$emit("ok", { content: this.content, tag: this.tag });
      this.dlgVisible = false;
    }
  }
};
</script>
<style type="scss" scoped>
.inlineChoice {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.choiceField {
  min-width: 80px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 5px;
  border: 1px dashed #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.titleLine {
  line-height: 30px;
}
</style>
